export default __webpack_public_path__ + "static/12_23-cdb1668c704cf2f579a98c05a5f5062b.png";